import React, { Component } from 'react';
import './App.css';
import Highlights from './Highlights'

class App extends Component {
  render() {
    return (
      <div>
        <Highlights></Highlights>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js